import { useState, useRef, useEffect } from "react"
import ResizeObserver from "resize-observer-polyfill"

export const fbTrack = (a, b) => {
  if (process.env.NODE_ENV === `production` && typeof fbq === `function`) {
    fbq(a, b) //eslint-disable-line no-undef
  }
}

export const isBrowser = typeof window !== "undefined"

export const setLocalStorage = (key, value) => {
  if (isBrowser) return localStorage.setItem(key, JSON.stringify(value))
}
export const getLocalStorage = key => {
  if (isBrowser) return JSON.parse(localStorage.getItem(key) || null)
}

export const unique = (value, index, self) => {
  return self.indexOf(value) === index
}

export const reduceBundleItems = (accumulator, bundleItem) => {
  return accumulator + Number(bundleItem.quantity)
}

export function usePrevious(value) {
  const ref = useRef()
  useEffect(() => void (ref.current = value), [value])
  return ref.current
}

export function lockScroll(lock) {
  if (!isBrowser) return
  if (lock) {
    document.body.style.setProperty("overflow", "hidden")
  } else {
    document.body.style.overflow = "scroll"
  }
}

export function useMeasure() {
  const ref = useRef()
  const [bounds, set] = useState({ left: 0, top: 0, width: 0, height: 0 })
  const [ro] = useState(
    () => new ResizeObserver(([entry]) => set(entry.contentRect))
  )
  useEffect(() => {
    if (ref.current) ro.observe(ref.current)
    return () => ro.disconnect()
  }, []) //eslint-disable-line
  return [{ ref }, bounds]
}

export function formatProductData(productNodes, liveProducts) {
  return productNodes.map(p => {
    const product = {
      title: p.title,
      ingredients: p.ingredients,
      productImage: p.primaryImage.asset,
      mobileImage: p.mobileImage.asset,
      nutritionInfoImage: p.nutritionFacts.asset,
      productId: p.shopifyId,
      description: p.description,
      disabled: p.disabled,
      primaryColor: p.primaryColor.hex,
      secondaryColor: p.secondaryColor.hex,
      backgroundColor: p.backgroundColor.hex,
    }

    liveProducts.forEach(lp => {
      if (p.shopifyId === lp.id) {
        product.available = lp.availableForSale
      }
    })

    p.variants.forEach(v => {
      product[v.title] = v.shopifyId
    })

    return product
  })
}
